import React from "react";
import {
  Loader2,
  CheckCircle2,
  Mail,
  Calendar,
  FolderOpen,
  MessageSquare,
  Users,
  Video,
  Sparkles,
} from "lucide-react";
import type { ToolCall, ToolResultInfo } from "./types";

const TOOL_ICONS: Record<string, typeof Mail> = {
  get_inbox_summary: Mail,
  search_emails: Mail,
  get_drafts: Mail,
  send_email: Mail,
  get_upcoming_events: Calendar,
  create_event: Calendar,
  list_recent_files: FolderOpen,
  search_files: FolderOpen,
  get_unread_messages: MessageSquare,
  get_mentions: MessageSquare,
  search_contacts: Users,
  get_my_profile: Users,
  schedule_meeting: Video,
  get_daily_briefing: Sparkles,
};

const TOOL_LABELS: Record<string, string> = {
  get_inbox_summary: "Checking your inbox",
  search_emails: "Searching emails",
  get_drafts: "Looking at your drafts",
  send_email: "Sending email",
  get_upcoming_events: "Checking your calendar",
  create_event: "Creating event",
  list_recent_files: "Browsing your files",
  search_files: "Searching files",
  get_unread_messages: "Checking unread chats",
  get_mentions: "Looking for mentions",
  search_contacts: "Searching contacts",
  get_my_profile: "Fetching your profile",
  schedule_meeting: "Setting up meeting",
  get_daily_briefing: "Preparing your briefing",
};

interface ToolActivityProps {
  toolCalls: ToolCall[];
  toolResults: ToolResultInfo[];
}

export const ToolActivity: React.FC<ToolActivityProps> = ({ toolCalls, toolResults }) => {
  if (toolCalls.length === 0) return null;

  return (
    <div className="space-y-1.5 mb-2">
      {toolCalls.map((tool, i) => {
        const hasResult = toolResults.some((r) => r.name === tool.name);
        const Icon = TOOL_ICONS[tool.name] ?? Sparkles;
        const label = TOOL_LABELS[tool.name] ?? tool.name;

        return (
          <div key={`${tool.name}-${i}`} className="flex items-center gap-2 text-xs text-zinc-400">
            {hasResult ? (
              <CheckCircle2 className="size-3.5 text-green-400 shrink-0" />
            ) : (
              <Loader2 className="size-3.5 animate-spin shrink-0" />
            )}
            <Icon className="size-3.5 shrink-0" />
            <span>{label}{hasResult ? "" : "\u2026"}</span>
          </div>
        );
      })}
    </div>
  );
};
